export default __webpack_public_path__ + "static/media/2rest.4da4b808.JPG";